import { createListView, FilterType, ListView, ListViewColumn, ListViewColumnType } from '../../UI/view/list-view';
import { dewarCustomerStore } from '../../../store/store';
import { usaStates } from '../../../data/states';
import { DewarRefreshButton } from './DewarRefreshButton';

import { customerPermissions } from './customer-data-source';
import { GetJDEInfoFromCST } from '../../../services/requests/billing/dewar-billing-requests';

export const dewarCustomerList: ListView = {
  permissions: customerPermissions,
  toolbar: [
    {
      component: DewarRefreshButton,
    }
  ],
  filters: [
    {
      type: FilterType.combo,
      label: 'State',
      fieldName: 'state',
      options: () => [...Object.keys(usaStates)]
    },
    {
      type: FilterType.multiselect,
      fieldName: 'accountType',
      filterValue: { 'CBT': true, 'DNU': false, 'CST': true },
      options: () => ['CBT', 'DNU', 'CST']
    },
    {
      type: FilterType.simple,
      label: 'International',
      fieldName: 'isInternational',
      filterValue: false
    },
  ],
  columns: [
    {
      Header: 'Customer #',
      accessor: 'site',
      type: ListViewColumnType.linkEdit,
      linkPath: ({ value, row }) => `/customers/edit/dewars/${value}`
    },
    {
      Header: 'Name',
      accessor: 'accountName',
      defaultSort: true,
    },
    {
      Header: 'Address',
      accessor: 'address1',
      serverExpression: `address1 & " " & address2`,
      Cell: ({ row }) => row.original.address1 + ' ' + row.original.address2
    },
    {
      Header: 'City',
      accessor: 'city',
    },
    {
      Header: 'State',
      accessor: 'state',
    },
    {
      Header: 'CBT',
      accessor: 'billToNumber',
    },
    {
      Header: 'CBT Name',
      accessor: 'billToName',
    },
    {
      Header: 'Type',
      accessor: 'accountType',
    },
  ] as ListViewColumn[],
  breadcrumbs: [
    {
      name: 'Customers',
      icon: 'people',
      to: '/customers',
    },
  ],
};

export const DewarCustomerList = createListView(dewarCustomerList, dewarCustomerStore as any);

export const DewarCustomerSelectList = createListView({
  ...dewarCustomerList,
  noGlobalFilterPadding: true,
  toolbar: undefined,
  selectionMode: 'single',
  columns: [
    {
      type: ListViewColumnType.radio,
      accessor: 'checked',
      excludeGlobalFilter: true,
    },
    ...dewarCustomerList.columns
  ]
}, dewarCustomerStore as any);

export const DewarCustomerSelectList2 = createListView({
  ...dewarCustomerList,
  noGlobalFilterPadding: true,
  toolbar: undefined,
  selectionMode: 'single',
  noPagingPadding: true,
  columns: [
    {
      type: ListViewColumnType.radio,
      accessor: 'checked',
      excludeGlobalFilter: true,
    },
    ...dewarCustomerList.columns
  ],
  onSelection: async (sel, setValue) => {
    const cst = sel?.length ? sel[0].site : null;
    const jdeInfo = await GetJDEInfoFromCST(cst);
    setValue('customerName', jdeInfo.customerName);
    setValue('city', jdeInfo.city);
    setValue('state', jdeInfo.state);
    setValue('address', `${jdeInfo.address}`.trim());
    setValue('zip', jdeInfo.zip);
  }
}, dewarCustomerStore as any);